var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import DataBox from '~/components/common/data-box.vue';
import FileUpload from '~/components/common/file-upload.vue';
import { Prop, Emit } from "vue-property-decorator";
import { Dependencies } from '~/core/decorator';
import { CaseOperatorPageService } from '~/services/domain-service/case-operator-page.service.ts';
import { FileUploadService } from "~/services/file-service/file-upload.service";
import { State, namespace } from "vuex-class";
import { MENU_CHANNEL } from "~/config/enum.config";
var CollectionExecutionModule = namespace('collection-execution');
var EnclosureStep = /** @class */ (function (_super) {
    __extends(EnclosureStep, _super);
    function EnclosureStep() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fileList = [];
        _this.formData = {
            legalStatus: "ENCLOSURE",
            fileRemark: "",
            id: "",
            fileIds: []
        };
        _this.dataSet = [];
        _this.submitLoading = false;
        _this.srcList = [];
        return _this;
    }
    Object.defineProperty(EnclosureStep.prototype, "isShow", {
        get: function () {
            var _this = this;
            var arr = [MENU_CHANNEL.Legal_personal, MENU_CHANNEL.Legal_team, MENU_CHANNEL.Assist_legal];
            if (arr.find(function (v) { return _this.menuChannel === v; })) {
                // 添加催记显示保存按钮 或编辑催记 与该登录用户一致显示
                if (!this.operatorId || this.operatorId === this.userData.id)
                    return true;
                else
                    return false;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    EnclosureStep.prototype.previousStepEmit = function () { };
    EnclosureStep.prototype.emitSuccess = function () {
        if (this.id) {
            this.showLegalInfoById(this.id);
        }
        else {
            // this.showLegalInfo();
        }
    };
    EnclosureStep.prototype.onClickDowload = function (row) { };
    EnclosureStep.prototype.mounted = function () {
        if (this.id) {
            this.showLegalInfoById(this.id);
        }
        else {
            // this.showLegalInfo();
        }
    };
    EnclosureStep.prototype.showLegalInfo = function () {
        var _this = this;
        //查询上一条催记是否结案，回显数据
        this.caseOperatorPageService
            .queryUnClossCaseLegalRecord(this.caseId)
            .subscribe(function (data) {
            if (data) {
                _this.dataSet = data.legalFiles;
                _this.formData.id = data.id;
                _this.dataSet.forEach(function (item) {
                    _this.srcList.push(item.fileUrl);
                });
            }
        }, function (err) {
        });
    };
    EnclosureStep.prototype.showLegalInfoById = function (val) {
        var _this = this;
        this.caseOperatorPageService
            .queryCaseLegalRecordById(val)
            .subscribe(function (data) {
            if (data) {
                _this.formData.id = data.id;
                _this.formData.fileRemark = data.fileRemark;
                _this.dataSet = data.legalFiles;
                _this.dataSet.forEach(function (item) {
                    _this.srcList.push(item.fileUrl);
                });
            }
        }, function (err) {
        });
    };
    EnclosureStep.prototype.submit = function () {
        var _this = this;
        this.fileList.forEach(function (element) {
            if (element.response) {
                var file = {};
                if (_this.formData.id) {
                    file.legalId = _this.formData.id;
                }
                file.fileId = element.response.id;
                file.fileName = element.response.originalName;
                file.fileRemark = _this.formData.fileRemark;
                file.fileUrl = element.response.url;
                _this.formData.fileIds.push(file);
            }
        });
        if (this.menuChannel === MENU_CHANNEL.Assist_legal) {
            this.formData.assistId = this.otherData.assistId;
        }
        if (this.formData.fileIds.length > 0) {
            this.formData.caseId = this.caseId;
            this.caseOperatorPageService
                .addCaseLegalRecord(this.formData)
                .subscribe(function (data) {
                var form = _this.$refs["enclosure-step-form"];
                form.resetFields();
                _this.formData.id = "";
                _this.emitSuccess();
                _this.fileList = [];
                _this.$message.success('法催催记附件已添加成功，如需修改请在法务详情中进行修改');
            }, function (err) {
                _this.submitLoading = false;
            });
        }
    };
    EnclosureStep.prototype.onUploadRemove = function (file, fileList) {
        this.fileList = fileList;
    };
    EnclosureStep.prototype.deleteFiles = function () {
        this.fileList = [];
        this.formData.fileIds = [];
    };
    __decorate([
        Dependencies(CaseOperatorPageService)
    ], EnclosureStep.prototype, "caseOperatorPageService", void 0);
    __decorate([
        Dependencies(FileUploadService)
    ], EnclosureStep.prototype, "fileUploadService", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], EnclosureStep.prototype, "caseId", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], EnclosureStep.prototype, "menuChannel", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], EnclosureStep.prototype, "otherData", void 0);
    __decorate([
        Prop({ type: String, required: false })
    ], EnclosureStep.prototype, "id", void 0);
    __decorate([
        Prop({ type: String })
    ], EnclosureStep.prototype, "operatorId", void 0);
    __decorate([
        State
    ], EnclosureStep.prototype, "userData", void 0);
    __decorate([
        Emit('previousStep')
    ], EnclosureStep.prototype, "previousStepEmit", null);
    __decorate([
        Emit('emitSuccess')
    ], EnclosureStep.prototype, "emitSuccess", null);
    EnclosureStep = __decorate([
        Component({
            components: {
                DataBox: DataBox,
                FileUpload: FileUpload
            }
        })
    ], EnclosureStep);
    return EnclosureStep;
}(Vue));
export default EnclosureStep;
